// GENERATED by the @lib/i18n:sync Nx generator. Do not edit.
// Declare libraries in this project's `project.json` under `metadata.i18n.libraries`,
// then run `nx sync`.
import type { FormsMessageKey } from '@lib/forms/lib/types/FormsMessageKey'
import { getExtractedI18nMessages as getFormsMessages } from '@lib/forms/lib/utils/getExtractedI18nMessages'
import type { UiSharedMessageKey } from '@lib/ui-shared/lib/types/UiSharedMessageKey'
import { getExtractedI18nMessages as getUiSharedMessages } from '@lib/ui-shared/lib/utils/getExtractedI18nMessages'

/** Message keys contributed by the libraries this application merges. */
export type LibraryMessageKey = FormsMessageKey | UiSharedMessageKey

/**
 * Load and merge the extracted messages of every library this application declares. A library
 * tagged `i18n:lazy` is imported dynamically to preserve the app's code-splitting; every other
 * library is imported statically, straight from its getter module rather than its barrel, so no
 * component code lands in this chunk.
 */
export const loadLibraryMessages = async (): Promise<Record<string, string>> => {
  const catalogs = await Promise.all([Promise.resolve(getFormsMessages()), Promise.resolve(getUiSharedMessages())])

  return catalogs.reduce<Record<string, string>>((merged, catalog) => ({ ...merged, ...catalog }), {})
}
